var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person"},[_c('LeftView'),_c('div',{staticClass:"body"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }